module.exports = "/static/assets/4215c0114ad52c7983f5192673e0dbff.png";